import type { CMYKColor } from "./CMYKColor"
import type { RGBColor } from "./RGBColor"

// Union type for all color formats

export type Color = CMYKColor | RGBColor
